import type { FlightSession } from "./planning/types";

export const TRASH_RETENTION_DAYS = 90;

const ACTIVE_EXPIRY_PHASES = new Set(["planning", "preflight"]);
const EXPIRY_GRACE_MS = 2 * 60 * 60 * 1000;
const DAY_MS = 24 * 60 * 60 * 1000;

export function isExpiredSession(
  s: FlightSession,
  now: number = Date.now(),
): boolean {
  const plannedDate = s.planning?.plannedDate;
  const plannedTime = s.planning?.plannedTime;
  if (!plannedDate || !plannedTime) return false;
  if (!ACTIVE_EXPIRY_PHASES.has(s.currentPhase)) return false;
  const plannedMs = new Date(`${plannedDate}T${plannedTime}:00`).getTime();
  if (isNaN(plannedMs)) return false;
  const windowEndMs = plannedMs + EXPIRY_GRACE_MS;
  return windowEndMs < now;
}

export function daysLeftFor(
  deletedAt?: string | null,
  now: number = Date.now(),
): number {
  if (!deletedAt) return TRASH_RETENTION_DAYS;
  const ageMs = now - new Date(deletedAt).getTime();
  if (isNaN(ageMs)) return TRASH_RETENTION_DAYS;
  return Math.max(0, Math.ceil(TRASH_RETENTION_DAYS - ageMs / DAY_MS));
}

export const byCreatedDesc = (a: FlightSession, b: FlightSession): number =>
  new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
